/**
 * FleetManager V3 - Claims Widget
 * Open claims summary - clickable to navigate to claims
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle, ChevronRight } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../../shared/index.js';

export function ClaimsWidget({ data = {}, onNavigate }) {
  const { t } = useTranslation();
  const { open = 0, pending = 0, thisMonth = 0 } = data;

  const handleClick = () => {
    onNavigate?.('claims');
  };

  return (
    <Card
      className="cursor-pointer hover:ring-1 hover:ring-blue-500/50 transition-all"
      onClick={handleClick}
    >
      <CardHeader>
        <CardTitle icon={AlertTriangle} iconColor="text-amber-400">{t('dashboard.claims.title')}</CardTitle>
        <ChevronRight size={14} className="text-gray-400 dark:text-slate-500" />
      </CardHeader>

      <div className="grid grid-cols-2 gap-2">
        <div className="text-center p-3 bg-gray-100 dark:bg-slate-700/30 rounded-lg">
          <div className="text-2xl font-bold text-gray-900 dark:text-white">{open}</div>
          <div className="text-xs text-gray-500 dark:text-slate-400">{t('dashboard.claims.open')}</div>
        </div>
        <div className="text-center p-3 bg-gray-100 dark:bg-slate-700/30 rounded-lg">
          <div className="text-2xl font-bold text-amber-500 dark:text-amber-400">{pending}</div>
          <div className="text-xs text-gray-500 dark:text-slate-400">{t('dashboard.claims.pending')}</div>
        </div>
      </div>

      {thisMonth > 0 && (
        <div className="mt-2 pt-2 border-t border-gray-200 dark:border-slate-700/50 flex items-center justify-between">
          <span className="text-xs text-gray-500 dark:text-slate-400">{t('dashboard.claims.thisMonth')}</span>
          <span className="text-sm text-gray-900 dark:text-white">{t('dashboard.claims.newCount', { count: thisMonth })}</span>
        </div>
      )}
    </Card>
  );
}

export default ClaimsWidget;
